module.exports = __webpack_public_path__ + "img/dota-and-cs.e722f50b.svg";